/** para-node `InsurancePolicyStatus` (src/constants/insurance.constants.ts). */
export enum InsurancePolicyStatus {
  Active = 'active',
  Archived = 'archived',
}

/**
 * para-node `InsurancePolicyOperationType`. A REQUIRED query param on every policy-product
 * route — `@IsEnum` without `@IsOptional`, so omitting it is a 400.
 *
 * `Immutable` archives the current policy version, clones it at `version + 1`, migrates the
 * onboarding template step configs onto the clone, and applies the change there — so documents
 * contractors already submitted stay attached to the archived version. `Mutable` edits the
 * current row in place, which can invalidate those documents and force a recollect.
 */
export enum InsurancePolicyOperationType {
  Mutable = 'mutable',
  Immutable = 'immutable',
}

export enum InsurancePoliciesTableFields {
  name = 'name',
  permanentId = 'permanentId',
  products = 'products',
  createdAt = 'createdAt',
  actions = 'actions',
}

export enum InsurancePolicyProductsTableFields {
  product = 'product',
  allowOptOut = 'allowOptOut',
  feeCents = 'feeCents',
  feePercent = 'feePercent',
  feeCapCents = 'feeCapCents',
  feeFrequency = 'feeFrequency',
  contract = 'contract',
  description = 'description',
  actions = 'actions',
}
